import React from 'react';
import { getAuthToken } from '../lib/auth-store';
import { getApiUrl } from '@daater/shared';
import { useNotificationStore } from '../lib/notification-store';

export function useNotificationStream(): void {
  const setUnreadCount = useNotificationStore(s => s.setUnreadCount);

  React.useEffect(() => {
    const token = getAuthToken();
    if (!token) return;

    const url = `${getApiUrl()}/notifications/stream?token=${token}`;
    const es = new EventSource(url);

    es.onmessage = (event: MessageEvent) => {
      try {
        const data = JSON.parse(event.data as string) as { type: string; count: number };
        if (data.type === 'unread_count') {
          setUnreadCount(data.count);
        }
      } catch {
        // ignore malformed events
      }
    };

    return () => {
      es.close();
    };
  }, [setUnreadCount]);
}
